/*
 *
 * PartnersDestinationPage actions
 *
 */

const SCOPE = 'app/PartnersDestinationPage/';
export const ActionTypes = {
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_IS_404: `${SCOPE}SET_IS_404`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    SET_PAGE_HAS_MORE: `${SCOPE}SET_PAGE_HAS_MORE`,
    RESET_PAGE: `${SCOPE}RESET_PAGE`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_RECOMMENDS_IS_LOADED: `${SCOPE}SET_RECOMMENDS_IS_LOADED`,
    FETCH_RECOMMENDS: `${SCOPE}FETCH_RECOMMENDS`,
    FETCH_RECOMMENDS_STARTED: `${SCOPE}FETCH_RECOMMENDS_STARTED`,
    FETCH_RECOMMENDS_SUCCESSFULLY: `${SCOPE}FETCH_RECOMMENDS_SUCCESSFULLY`,
    FETCH_RECOMMENDS_FAILED: `${SCOPE}FETCH_RECOMMENDS_FAILED`,
    FETCH_RECOMMENDS_CANCELLED: `${SCOPE}FETCH_RECOMMENDS_CANCELLED`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const setPageHasMore = (hasMore) => ({ type: ActionTypes.SET_PAGE_HAS_MORE, hasMore });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const resetPage = () => ({ type: ActionTypes.RESET_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Recommends
 */
export const setRecommendsIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_RECOMMENDS_IS_LOADED,
    isLoaded,
});
export const fetchRecommends = () => ({ type: ActionTypes.FETCH_RECOMMENDS });
export const fetchRecommendsStarted = () => ({ type: ActionTypes.FETCH_RECOMMENDS_STARTED });
export const fetchRecommendsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY,
    res,
});
export const fetchRecommendsFailed = (error) => ({
    type: ActionTypes.FETCH_RECOMMENDS_FAILED,
    error,
});
export const fetchRecommendsCancelled = () => ({
    type: ActionTypes.FETCH_RECOMMENDS_CANCELLED,
});
